<template>
    <Popup
        buttonText="popupVoucherRedeem_btn"
        title="popupVoucherRedeem_title"
        v-bind:contentStyle="popupStyle"
        v-on:callback="closePopup"
    >
        <template #content>
            <p>{{ i18n.t('popupVoucherRedeem_introduction') }}</p>
            <p>{{ i18n.t('popupVoucherRedeem_introduction2') }}</p>
            <picture>
                <source v-bind:srcset="`${imageUrl.webp}`" type="image/webp">
                <img
                    v-bind:src="`${imageUrl.origin}`"
                    alt=""
                    aria-hidden="true"
                >
            </picture>
            <p>
                <I18nT keypath="popupVoucherRedeem_introduction3">
                    <template #tncs>
                        <a
                            class="PopupMsg_Voucher_Link_TnC"
                            v-bind:href="tncUrl"
                            target="_blank"
                            rel="noopener"
                        >{{ i18n.t('tncs') }}</a>
                    </template>
                </I18nT>
            </p>
        </template>
    </Popup>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import { computed, defineComponent } from 'vue';
    import Popup from '@/components/common/Popup.vue';
    import { useVoucherRedeemPopup } from '@/libraries/composables/popup/useVoucherRedeemPopup';
    import { i18n } from '@/libraries/i18n';
    import { useRootStore } from '@/stores/rootStore';

    export default defineComponent({
        name: 'PopupVoucherRedeem',
        components: {
            Popup,
        },
        emits: ['close'],
        setup(_, { emit }) {
            const { imageUrl, popupStyle } = useVoucherRedeemPopup();

            const { isSboTop } = storeToRefs(useRootStore());
            const tncUrl = computed(() => (isSboTop.value
                ? 'https://help.sbotop.com/article/35/sbotop-voucher-terms-and-conditions-1096.html'
                : 'http://help.sbobet.com/article/sbobet-voucher-terms-and-conditions-1430.html'));

            const closePopup = () => {
                emit('close');
            };

            return {
                closePopup,
                imageUrl,
                tncUrl,
                popupStyle,
                i18n,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/popupModal";
</style>
